import * as React from "react";
const NoSSR = ({
  children,
  fallback
}) => {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);
  if (!mounted) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, fallback);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export {
  NoSSR
};
